export default {
  active: '<a class="ais-show-more ais-show-more__active">Show less</a>',
  inactive: '<a class="ais-show-more ais-show-more__inactive">Show more</a>',
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/lib/show-more/defaultShowMoreTemplates.js